jQuery(function($){

  updateCartStuff();
  
  var non_private_browsing = true;

  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  detectPrivateMode(function(is_private) {
    if (is_private) {
      non_private_browsing = false;
    } 
  });

  if(isMobile || $(window).width() < 767){
    $('body').addClass('touchscreen')
  }
  
  // product: quantity increment
  $('.single-product .product-amount span.minus').click(function() {
    var oldQty = $('#quantity').val();
    if (oldQty > 0) {
      var newQty = parseFloat(oldQty) - 1;
    } else {
      newQty = 0;
    }
    $('#quantity').val(newQty);
  });
  $('.single-product .product-amount span.plus').click(function() {
    var oldQty = $('#quantity').val();
    var newQty = parseFloat(oldQty) + 1;
    $('#quantity').val(newQty);
  });

  if($('.single-product .hero-slider-items').length){    
    $('.single-product .hero-slider-items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      easing: "swing",
      speed: 350,
      arrows: true,
      nextArrow: $('.hero .arrow-right'),
      prevArrow: $('.hero .arrow-left'),      
      dots: true,
      customPaging: function (item, index) {
          // console.log(item);
          return '<button style="background:url(' + $(item.$slides[index])[0].src + ') center /cover no-repeat;"></button>';
      }
  })
  }
  
  // mailchimp
  /*$('.mailchimp-form').each(function() {
    var $this = $(this);
    var $message = $(this).prev('.mailchimp-message');
    $this.submit(function(e) {
      var url = $this.prop('action');
      $.ajax({
        type: "GET",
        url: url,
        data: $this.serialize(),
        cache: false,
        dataType: "jsonp",
        contentType: "application/json; charset=utf-8",
        error: function(err) {           
          $message.html('There was an error!');
        },
        success: function(data) {
          if (data.result != "success") {
            var firstchar = data.msg.charAt(0);
            if (firstchar == 0) {
              $message.html('Please enter a valid email address.');
            } else {
              var subscribeCheck = 'already subscribed';
              var theMsg = data.msg;
              if(theMsg.indexOf(subscribeCheck) != -1){
                $message.html('This email address is already subscribed.');
              } else {
                $message.html(data.msg);
              }
            }
          } else {
            $message.html('Thank you for subscribing!');
          }
        }
      });
      e.preventDefault();
    });
  });*/
  
  // promo bar  
  if ($('#promo').length) {
    $(window).load(function(){
      if(typeof(Storage) !== "undefined") {
        if (sessionStorage.redClayShowPromo != 1) {
          if (non_private_browsing) {
            $('#promo').show(0);
          }
        }
      }
    });
  }
  $('#promo .close').click(function(e) {
    e.preventDefault();
    $('#promo').fadeOut(300, function() {
      if(typeof(Storage) !== "undefined") {
        if (non_private_browsing) {
          sessionStorage.redClayShowPromo = 1;
        }
      }
    });
  });

});

//blog masonry
// $('.blog-grid .content').masonry({
//     // options
//     itemSelector: '.blog',
//     percentPosition: true
// });  
if($('.blog-grid').length){
  var $grid = $('.blog-grid .content').masonry({
      itemSelector: '.blog',
      percentPosition: true
  });
  $grid.imagesLoaded().progress( function() {
    $grid.masonry();
  });  
}
if($('.masonry-grid').length){
  var $grid = $('.masonry-grid').masonry({
      itemSelector: '.masonry-grid-item',
      percentPosition: true
  });
  $grid.imagesLoaded().progress( function() {
    $grid.masonry();
  });  
}

function addItem(form_id) {
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $('#' + form_id).serialize(),
      success: function(product) {
        updateCartStuff();
        $('.cart-items').addClass('open');
        $('.cart-overlay').addClass('reveal');   
        // KLAVIYO PRODUCT TRACKING
          var _learnq = window._learnq || [];
          var kl = {
              Name: `${product.product_title}`,
              ProductID: `${product.id}`,
              ImageURL: `${product.image}`,
              URL: `${window.location.origin}${product.url}`,
              Brand: `${product.vendor}`,
              Price: `${Shopify.formatMoney(product.final_price)}`,
              CompareAtPrice: `${Shopify.formatMoney(product.original_price)}`,
              VariantTitle: `${product.variant_title}`,
              VariantPrice: `${Shopify.formatMoney(product.final_price)}`,
              VariantImage: `${product.image}`,
              VariantSKU: `${product.sku}`,
              VariantID: `${product.variant_id}`,
              VariantOption1: `${product.variant_options[0] ? product.variant_options[0] : ""}`,
              VariantOption2: `${product.variant_options[1] ? product.variant_options[1] : ""}`,
              VariantOption3: `${product.variant_options[2] ? product.variant_options[2] : ""}`
          };
          _learnq.push(['track', 'Added to Cart', kl]);	             
      },
      error: function(obj, status) { 
  	    alert('The product you are trying to add is out of stock.');
      }
   });
}

function cartSubtract(variant_id, qty) {
 
  var data = 'updates[' + variant_id + ']=' + qty;
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        updateCartStuff();
      },
      error: function() {
		alert('There was an error.');
      }
  });
  
}

function cartAdd(variant_id, qty) {
 
  var data = 'updates[' + variant_id + ']=' + qty;
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        updateCartStuff();
      },
      error: function() {
        alert('There was an error.');
      }
  });
  
}

function cartRemove(variant_id) {
 
  var data = 'updates[' + variant_id + ']=0';
  
  $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        updateCartStuff();
      },
      error: function() {
		alert('There was an error.');
      }
  });
  
}

function updateCartStuff() {
  
  if (gift_wrapping_handle != '') {
  	doGiftWrappingFee();
  }
 
  $.ajax({
    
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        // console.log(cart)
        $(".cart-items .products").html("");

        $(".cart-items .subtotal .total-cost").html(
          Shopify.formatMoney(cart.total_price).replace(".00", "")
        );
        /* Upsell variables */
        const $cartUpsells = document.querySelector(".cart__drawer-upsells");
        const $cartUpsellItems = document.querySelectorAll(
          ".cart__drawer-upsells-item"
        );
        if (cart.item_count > 0) {
          $.each(cart.items, function (index, cartItem) {

            var item = "";

            item += '<div class="product-item">';
            item += '<div class="product-picture">';
            if(cartItem.image){
              item += '<img src="' + cartItem.image + '&width=200" alt="" width="100">';
            } else {
              item += '<img src="/assets/RC-hand-white.svg" alt="" height="100" width="100">';
            }
            item += "</div>";
            item += '<div class="product-middle">';
            item += '<div class="product-name">';
            item += "<div>" + cartItem.product_title + "</div>";
            if (
              cartItem.variant_title !== null &&
              cartItem.variant_title != "" &&
              !cartItem.product_title.includes("Gift Card")
            ) {
              item +=
                '<div class="hgc-font" style="margin-top:10px;">' +
                cartItem.variant_title +
                "</div>";
            }

            if(cartItem.properties !== null && Object.keys(cartItem.properties).includes("Preorder")){
              item += '<div class="cart-tag" style="margin-top:10px;">Preorder</div>';
            }

            if (
              cartItem.discounts.length
            ) {
              cartItem.discounts.map(function(d, i){
                item +=
                  '<div class="cart-item-discount hgc-font">Discount:' +
                  d.title +
                  "</div>";
              })
            }


            item += '<div class="product-remove">';
            item +=
              '<span onclick="cartRemove(' + "'" + cartItem.key + "'" + '); return false;">Remove</span>';
            item += "</div>";

            item += "</div>";


            if (cartItem.handle == gift_wrapping_handle) {
              // don't display +/-
            } else {
              item += '<div class="product-amount">';
              if (!cartItem.discounts.length){
                item += '<span class="minus" onclick="cartSubtract(' + "'" + cartItem.key + "'" + ", " + (cartItem.quantity - 1) +'); return false;">-</span>';
              }
              item += " " + cartItem.quantity + " ";
              if (!cartItem.discounts.length){
                item += '<span class="plus" onclick="cartAdd(' + "'" + cartItem.key + "'" + ", " + (cartItem.quantity + 1) +'); return false;">+</span>';
              }
              item += "</div>";
            }
            item += "</div>";
            if(cartItem.price > cartItem.discounted_price){
              item +=
                '<p class="product-cost" style="display:flex;gap:4px;"><span style="text-decoration:line-through">' +
                Shopify.formatMoney(cartItem.price).replace(".00", "") +
                "</span><span>" + 
                Shopify.formatMoney(cartItem.discounted_price).replace(".00", "")
                + "</p>";
            } else {       
              item +=
                '<p class="product-cost">' +
                Shopify.formatMoney(cartItem.discounted_price).replace(".00", "") +
                "</p>";
            }
            item += "</div>";

            $(".cart-items .products").append(item);
            		// UPSELLS
					if (window.upsells !== undefined && window.upsells.length) {
						if (window.upsells.includes(cartItem.variant_id)) {
							var the_index = window.upsells.indexOf(cartItem.variant_id);
							window.upsells.splice(the_index, 1); // removes the variant id from the upsells array
						}
					}
          });

          $(".cart-items .gift-wrap .message input").val(cart.note);

          $(".cart-items .checkout").show(0);
          /* Upsell */
          if ($cartUpsells !== null) {
            if (window.upsells !== undefined && window.upsells.length) {
              $cartUpsells.style.display = "block";
              if (
                window.randomizeUpsells !== undefined &&
                window.randomizeUpsells === true
              ) {
                shuffleArray(window.upsells);
              }
              $cartUpsellItems.forEach((u) => {
                u.style.display = "none";
              });
              document.querySelector(
                `.cart__drawer-upsells .upsell-${window.upsells[0]}`
              ).style = "block";
            }
            if (!window.upsells.length) {
              $cartUpsells.style.display = "none";
            }
          }
        } else {
          $(".cart-items .products").append(
            '<div style="text-align:center;">Your cart is empty.</div>'
          );
          $(".cart-items .checkout").hide(0);
          /* Upsell */
          if ($cartUpsells !== null) {
            $cartUpsells.style.display = "none";
          }
        }

        $("header .account .count").html(cart.item_count);

        $(".cart-items .count").html(cart.item_count);

       
      }  
  });
  
}

/* QUICK SHOP */
if($('.quick-shop form').length){
  $('.quick-shop form input[type="radio"]').on('change', function(){
    var price = $(this).attr('data-price')
    var radioIndex = $(this).parent().index();
    var $card = $(this).parents('.product-item')
    var $form = $(this).parents('form');
    var $formSelect = $form .children('select')
    var $formOption = $formSelect.children('option');
    var $formButton = $form.find('.btn')
    $formSelect.val($formOption.eq(radioIndex).val());
    $formButton.val('Add to Cart - ' + price)
    $card.find('.product-cost').text(price)
  })
}

/**
 * Shuffles an array
 * @example 
 * 
 * let arr = [0,1,2]
 * shuffleArray(arr)
 * console.log(arr) => [1,0,2]
 * 
 */
  const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
}

/* Bundle Cart Upsell */
$(".addAllProducts").on('click', function (event) {
  event.preventDefault();
  var productList = $(this).data('product-list');
  Shopify.queue = [];
  var newArray = productList.split(',');
  for (var i = 0; i < newArray.length; i++) {
    product = newArray[i]
    Shopify.queue.push({
      variantId: product,
    });
  }
  Shopify.moveAlong = function () {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      var data = 'id=' + request.variantId + '&quantity=1'
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function (res) {
          Shopify.moveAlong();
        },
        error: function () {
          // if it's not last one Move Along else update the cart number with the current quantity
          if (Shopify.queue.length) {
            Shopify.moveAlong()
          } else {
            addToCartOk();
          }
        }
      });
    }
    else {
      addToCartOk();
    }
  }
  Shopify.moveAlong();
});
function addToCartOk() {
  updateCartStuff();
  $('.cart-items').addClass('open');
  $('.cart-overlay').addClass('reveal');
  //$('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>");
}